/* eslint-disable local-rules/too-complex-useeffects */
import {useHistory} from '@aboutyou/router';
import {
  LoadingSpinner,
  useIsomorphicLayoutEffect,
} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';
import {DEEP_LINKS} from './useDeepLinkOpener';

export const DeepLinkLoaderPage: FC<{
  openCouponWallet?: boolean;
  openCoinsWallet?: boolean;
  openNewsletter?: boolean;
  openCoinsHistory?: boolean;
}> = ({
  openCouponWallet,
  openCoinsHistory,
  openCoinsWallet,
  openNewsletter,
}) => {
  const {push, location} = useHistory();

  useIsomorphicLayoutEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (openCouponWallet) {
      searchParams.set(DEEP_LINKS.cw, 'true');
      push(`/?${searchParams.toString()}`);
    }

    if (openCoinsWallet) {
      searchParams.set(DEEP_LINKS.coins, 'true');
      push(`/?${searchParams.toString()}`);
    }

    if (openNewsletter) {
      searchParams.set(DEEP_LINKS.newsletterSubscription, 'true');
      push(`/?${searchParams.toString()}`);
    }

    if (openCoinsHistory) {
      searchParams.set(DEEP_LINKS.coinsHistory, 'true');
      push(`/?${searchParams.toString()}`);
    }
  }, []);

  return (
    <Wrapper>
      <StyledLoadingSpinner size="80px" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
`;

const StyledLoadingSpinner = styled(LoadingSpinner)`
  flex: 1;
  margin-top: 150px;
`;
